import React, { useCallback, useEffect, useState } from 'react';
import { Plane } from 'lucide-react';
import { api, useAuth } from '../../context/AuthContext';
import { DatumFeld } from '../DatumFeld';

const de = (d) => (d ? d.split('-').reverse().join('.') : '');

const Zeile = ({ p, team, darf, onDone }) => {
  const [f, setF] = useState({ von: p.abwesenheit?.von || '', bis: p.abwesenheit?.bis || '', vertretung_id: p.abwesenheit?.vertretung_id || '' });
  const [err, setErr] = useState('');
  const speichern = async (leer) => {
    setErr('');
    try { await api.put(`/kanzlei/abwesenheit/${p.user_id}`, leer ? {} : f); onDone(); } catch (e) { setErr(e?.response?.data?.detail || 'Fehler'); }
  };
  const vertr = team.find((t) => t.user_id === p.abwesenheit?.vertretung_id);
  return (
    <li className="py-2 flex flex-wrap items-center gap-2 text-sm" data-testid={`abwesenheit-${p.user_id}`}>
      <span className="w-40 text-[#1B3A5C] truncate">{p.name || p.email}</span>
      {!darf ? <span className="text-xs text-gray-500">{p.abwesenheit ? `abwesend ${de(p.abwesenheit.von)}–${de(p.abwesenheit.bis)} · Vertretung ${vertr?.name || '—'}` : 'anwesend'}</span> : (<>
        <DatumFeld className="h-8 w-32 px-2 border border-gray-300 rounded-[10px]" value={f.von} onChange={(v) => setF({ ...f, von: v })} testId={`abwesenheit-von-${p.user_id}`} />
        <DatumFeld className="h-8 w-32 px-2 border border-gray-300 rounded-[10px]" value={f.bis} min={f.von || undefined} onChange={(v) => setF({ ...f, bis: v })} testId={`abwesenheit-bis-${p.user_id}`} />
        <select value={f.vertretung_id} onChange={(e) => setF({ ...f, vertretung_id: e.target.value })} className="h-8 px-2 border border-gray-300 rounded-[10px] text-sm" data-testid={`abwesenheit-vertretung-${p.user_id}`}>
          <option value="">Vertretung wählen</option>{team.filter((t) => t.user_id !== p.user_id).map((t) => <option key={t.user_id} value={t.user_id}>{t.name || t.email}</option>)}
        </select>
        <button type="button" onClick={() => speichern(false)} disabled={!f.von || !f.vertretung_id} className="h-8 px-3 rounded-[10px] bg-[#1B3A5C] text-white text-xs disabled:opacity-50" data-testid={`abwesenheit-speichern-${p.user_id}`}>Speichern</button>
        {p.abwesenheit && <button type="button" onClick={() => speichern(true)} className="text-xs text-rose-600" data-testid={`abwesenheit-loeschen-${p.user_id}`}>Aufheben</button>}
      </>)}
      {err && <span className="text-xs text-rose-600 w-full">{err}</span>}
    </li>
  );
};

export const Abwesenheiten = () => {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get('/kanzlei/abwesenheiten').then((r) => setD(r.data)).catch(() => setD(false)), []);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  return (
    <section className="bg-white border border-gray-200 rounded-2xl p-5 mb-6" data-testid="abwesenheiten">
      <h2 className="flex items-center gap-2 text-[#1B3A5C] font-medium mb-1"><Plane className="w-4 h-4 text-[#b8893d]" /> Abwesenheit und Vertretung</h2>
      <p className="text-xs text-gray-500 mb-3">In der Abwesenheit gehen Zuständigkeiten im Dashboard automatisch auf die Vertretung über; Mandanten sehen in der Akte, wer vertritt.</p>
      <ul className="divide-y divide-gray-100">{d.items.map((p) => <Zeile key={`${p.user_id}-${p.abwesenheit?.am || ''}`} p={p} team={d.items} darf={user?.role === 'admin' || p.user_id === user?.user_id} onDone={load} />)}</ul>
    </section>
  );
};
